export const LOGIN_FORM_SUBMIT = 'LOGIN_FORM_SUBMIT'
export const LOGIN_FORM_SUBMIT_SUCCESS = 'LOGIN_FORM_SUBMIT_SUCCESS'
export const LOGIN_FORM_SUBMIT_FAILED = 'LOGIN_FORM_SUBMIT_FAILED'
export const CLOSE_LOGIN_SNACKBAR = 'CLOSE_LOGIN_SNACKBAR'
export const CLIENT_SET = 'CLIENT_SET'
export const CLIENT_UNSET = 'CLIENT_UNSET'
export const LOGOUT = 'LOGOUT'
export const GET_LANG_FROM_SITE = 'GET_LANG_FROM_SITE'
export const RESET_PASSWORD_FORM_SUBMIT = 'RESET_PASSWORD_FORM_SUBMIT'
export const RESET_PASSWORD_SUBMIT_SUCCESS = 'RESET_PASSWORD_SUBMIT_SUCCESS'
export const RESET_PASSWORD_SUBMIT_FAILED = 'RESET_PASSWORD_SUBMIT_FAILED'
export const HIDE_RESET_PASSWORD_SNACKBAR = 'HIDE_RESET_PASSWORD_SNACKBAR'

export const REGISTER_FORM_SUBMIT = 'REGISTER_FORM_SUBMIT'
export const REGISTER_FORM_SUBMIT_SUCCESS = 'REGISTER_FORM_SUBMIT_SUCCESS'
export const REGISTER_FORM_SUBMIT_FAILED = 'REGISTER_FORM_SUBMIT_FAILED'
export const REGISTER_FORM_SUBMIT_USER_EXIST_ERROR =
  'REGISTER_FORM_SUBMIT_USER_EXIST_ERROR'
export const CLOSE_REGISTER_SNACKBAR = 'CLOSE_REGISTER_SNACKBAR'
export const LOAD_REGISTER_FROM_SITE = 'LOAD_REGISTER_FROM_SITE'

export const CLOSE_PASSWORD_SNACKBAR = 'CLOSE_PASSWORD_SNACKBAR'

export const UPDATE_PROFILE = '@@profile/UPDATE_PROFILE'
export const UPDATE_PROFILE_SUCCESS = '@@profile/UPDATE_PROFILE_SUCCESS'
export const UPDATE_PROFILE_FAILED = '@@profile/UPDATE_PROFILE_FAILED'
export const LOAD_PROFILE_SUCCESS = '@@profile/LOAD_PROFILE_SUCCESS'
export const LOAD_PROFILE_FAILED = '@@profile/LOAD_PROFILE_FAILED'
export const LOAD_PROFILE_START = '@@profile/LOAD_PROFILE_START'
export const CLOSE_PROFILE_SNACKBAR = '@@profile/CLOSE_PROFILE_SNACKBAR'
export const ON_PASSWORD_UPDATE = '@@profile/ON_PASSWORD_UPDATE'
export const PASSWORD_UPDATE_SUCCESS = '@@profile/PASSWORD_UPDATE_SUCCESS'
export const PASSWORD_UPDATE_FAILED = '@@profile/PASSWORD_UPDATE_FAILED'

export const LOCATION_CHANGE = '@@router/LOCATION_CHANGE'
export const LANGUAGE_CHANGE = '@@lang/LANGUAGE_CHANGE'

export const VALIDATE_TOKEN = 'VALIDATE_TOKEN'

// huong - EMPLOPYERS LOGIN APPLICATION

export const GET_FIELD_OF_WORK = 'GET_FIELD_OF_WORK'
export const GET_FIELD_OF_WORK_SUCCESS = 'GET_FIELD_OF_WORK_SUCCESS'

export const GET_E_INVOICE_OPERATORS =
  '@@companyProfile/GET_E_INVOICE_OPERATORS'
export const GET_E_INVOICE_OPERATORS_SUCCESS =
  '@@companyProfile/GET_E_INVOICE_OPERATORS_SUCCESS'
export const GET_E_INVOICE_OPERATORS_FAILED =
  '@@companyProfile/GET_E_INVOICE_OPERATORS_FAILED'

export const ADD_LIGHT_ENTREPRENEURS =
  '@@lightEntrepreneurs/ADD_LIGHT_ENTREPRENEURS'
export const ADD_LIGHT_ENTREPRENEURS_SUCCESS =
  '@@lightEntrepreneurs/ADD_LIGHT_ENTREPRENEURS_SUCCESS'
export const ADD_LIGHT_ENTREPRENEURS_FAILED =
  '@@lightEntrepreneurs/ADD_LIGHT_ENTREPRENEURS_FAILED'
export const REMOVE_LIGHT_ENTREPRENEURS =
  '@@lightEntrepreneurs/REMOVE_LIGHT_ENTREPRENEURS'
export const REMOVE_LIGHT_ENTREPRENEURS_SUCCESS =
  '@@lightEntrepreneurs/REMOVE_LIGHT_ENTREPRENEURS_SUCCESS'
export const REMOVE_LIGHT_ENTREPRENEURS_FAILED =
  '@@lightEntrepreneurs/REMOVE_LIGHT_ENTREPRENEURS_FAILED'
export const GET_LIGHT_ENTREPRENEURS =
  '@@lightEntrepreneurs/GET_LIGHT_ENTREPRENEURS'
export const GET_LIGHT_ENTREPRENEURS_SUCCESS =
  '@@lightEntrepreneurs/GET_LIGHT_ENTREPRENEURS_SUCCESS'
export const GET_LIGHT_ENTREPRENEURS_FAILED =
  '@@lightEntrepreneurs/GET_LIGHT_ENTREPRENEURS_FAILED'
export const SET_FAVOURITE_ENTREPRENEURS =
  '@@lightEntrepreneurs/SET_FAVOURITE_ENTREPRENEURS'
export const SET_FAVOURITE_ENTREPRENEURS_FAILED =
  '@@lightEntrepreneurs/SET_FAVOURITE_ENTREPRENEURS_FAILED'
export const LIGHT_ENTREPRENEURS_PAGE_CHANGE =
  '@@lightEntrepreneurs/LIGHT_ENTREPRENEURS_PAGE_CHANGE'
export const OFFER_AN_ASSIGNMENT_AGREEMENT =
  '@@lightEntrepreneurs/OFFER_AN_ASSIGNMENT_AGREEMENT'
export const CANCEL_OFFER = 'CANCEL_OFFER'
export const COMPLETE_OFFER_FORM = 'COMPLETE_OFFER_FORM'
export const OPEN_WARNING_CLOSE_COMPLETE_OFFER_FORM =
  'OPEN_WARNING_CLOSE_COMPLETE_OFFER_FORM'
export const CLOSE_WARNING_CLOSE_COMPLETE_OFFER_FORM =
  'CLOSE_WARNING_CLOSE_COMPLETE_OFFER_FORM'
export const CLOSE_LIGHT_ENTREPRENEURS_SNACKBAR =
  '@@lightEntrepreneurs/CLOSE_LIGHT_ENTREPRENEURS_SNACKBAR'
export const PREVIEW_CONTRACT = '@@lightEntrepreneurs/PREVIEW_CONTRACT'
export const PREVIEW_CONTRACT_SUCCESS =
  '@@lightEntrepreneurs/PREVIEW_CONTRACT_SUCCESS'
export const PREVIEW_CONTRACT_FAILED =
  '@@lightEntrepreneurs/PREVIEW_CONTRACT_FAILED'
export const LOAD_PREVIEW_PDF = '@@lightEntrepreneurs/LOAD_PREVIEW_PDF'
export const CLOSE_LOAD_PREVIEW_PDF =
  '@@lightEntrepreneurs/CLOSE_LOAD_PREVIEW_PDF'
export const LOAD_SIGN_AND_SEND = 'LOAD_SIGN_AND_SEND'
export const CLOSE_LOAD_SIGN_AND_SEND = 'CLOSE_LOAD_SIGN_AND_SEND'
export const SIGN_CONTRACT_SCREEN = '@@lightEntrepreneurs/SIGN_CONTRACT_SCREEN'
export const CLOSE_SIGN_CONTRACT_SCREEN =
  '@@lightEntrepreneurs/CLOSE_SIGN_CONTRACT_SCREEN'
export const SIGN_AND_SEND_CONTRACT =
  '@@lightEntrepreneurs/SIGN_AND_SEND_CONTRACT'
export const SIGN_AND_SEND_CONTRACT_SUCCESS =
  '@@lightEntrepreneurs/SIGN_AND_SEND_CONTRACT_SUCCESS'
export const SIGN_AND_SEND_CONTRACT_FAILED =
  '@@lightEntrepreneurs/SIGN_AND_SEND_CONTRACT_FAILED'

export const GET_ASSIGNMENTS = '@@assignments/GET_ASSIGNMENTS'
export const GET_ASSIGNMENTS_SUCCESS = '@@assignments/GET_ASSIGNMENTS_SUCCESS'
export const GET_ASSIGNMENTS_FAILED = '@@assignments/GET_ASSIGNMENTS_FAILED'
export const OPEN_ASSIGNMENT_FORM_DIALOG =
  '@@assignments/OPEN_ASSIGNMENT_FORM_DIALOG'
export const CLOSE_ASSIGNMENT_FORM_DIALOG =
  '@@assignments/CLOSE_ASSIGNMENT_FORM_DIALOG'
export const PREVIEW_NEW_ASSIGNMENT = '@@assignments/PREVIEW_NEW_ASSIGNMENT'
export const CLOSE_PREVIEW_NEW_ASSIGNMENT =
  '@@assignments/CLOSE_PREVIEW_NEW_ASSIGNMENT'
export const ADD_NEW_ASSIGNMENT = '@@assignments/ADD_NEW_ASSIGNMENT'
export const ADD_NEW_ASSIGNMENT_SUCCESS =
  '@@assignments/ADD_NEW_ASSIGNMENT_SUCCESS'
export const ADD_NEW_ASSIGNMENT_FAILED =
  '@@assignments/ADD_NEW_ASSIGNMENT_FAILED'
export const GET_ASSIGNMENT_BY_ID = '@@assignments/GET_ASSIGNMENT_BY_ID'
export const GET_ASSIGNMENT_BY_ID_SUCCESS =
  '@@assignments/GET_ASSIGNMENT_BY_ID_SUCCESS'
export const GET_ASSIGNMENT_BY_ID_FAILED =
  '@@assignments/GET_ASSIGNMENT_BY_ID_FAILED'
export const SET_ASSIGNMENT_FORM_READONLY =
  '@@assignments/SET_ASSIGNMENT_FORM_READONLY'
export const CANCEL_EDIT_ASSIGNMENT = '@@assignments/CANCEL_EDIT_ASSIGNMENT'
export const UPDATE_ASSIGNMENT_SUCCESS =
  '@@assignments/UPDATE_ASSIGNMENT_SUCCESS'
export const UPDATE_ASSIGNMENT_FAILED = '@@assignments/UPDATE_ASSIGNMENT_FAILED'
export const DELETE_ASSIGNMENT = '@@assignments/DELETE_ASSIGNMENT'
export const DELETE_ASSIGNMENT_SUCCESS =
  '@@assignments/DELETE_ASSIGNMENT_SUCCESS'
export const DELETE_ASSIGNMENT_FAILED = '@@assignments/DELETE_ASSIGNMENT_FAILED'
export const CLOSE_ASSIGNMENT_SNACKBAR =
  '@@assignments/CLOSE_ASSIGNMENT_SNACKBAR'
export const COPY_ASSIGNMENT = '@@assignments/COPY_ASSIGNMENT'
export const COPY_ASSIGNMENT_SUCCESS = '@@assignments/COPY_ASSIGNMENT_SUCCESS'
export const COPY_ASSIGNMENT_FAILED = '@@assignments/COPY_ASSIGNMENT_FAILED'
export const SAVE_ASSIGNMENT_AS_DRAFT = '@@assignments/SAVE_ASSIGNMENT_AS_DRAFT'
export const SAVE_ASSIGNMENT_AS_DRAFT_SUCCESS =
  '@@assignments/SAVE_ASSIGNMENT_AS_DRAFT_SUCCESS'
export const SAVE_ASSIGNMENT_AS_DRAFT_FAILED =
  '@@assignments/SAVE_ASSIGNMENT_AS_DRAFT_FAILED'
export const GET_EMPLOYER_CONTRACT_LIST = 'GET_EMPLOYER_CONTRACT_LIST'
export const GET_EMPLOYER_CONTRACT_LIST_SUCCESS =
  'GET_EMPLOYER_CONTRACT_LIST_SUCCESS'
export const GET_EMPLOYER_CONTRACT_LIST_FAILED =
  'GET_EMPLOYER_CONTRACT_LIST_FAILED'
export const ASSIGNMENT_PAGE_CHANGE = 'ASSIGNMENT_PAGE_CHANGE'
export const PIN_ASSIGNMENT = '@@assignments/PIN_ASSIGNMENT'
export const PIN_ASSIGNMENT_SUCCESS = '@@assignments/PIN_ASSIGNMENT_SUCCESS'
export const PIN_ASSIGNMENT_FAILED = '@@assignments/PIN_ASSIGNMENT_FAILED'

export const CHANGE_ROWS_PER_PAGE = 'CHANGE_ROWS_PER_PAGE'

export const GET_APPLICANT_DETAILS = '@@applications/GET_APPLICANT_DETAILS'
export const GET_APPLICANT_DETAILS_SUCCESS =
  '@@applications/GET_APPLICANT_DETAILS_SUCCESS'
export const GET_APPLICANT_DETAILS_FAILED =
  '@@applications/GET_APPLICANT_DETAILS_FAILED'
export const SELECTED_APPLICANT = '@@applications/SELECTED_APPLICANT'
export const UPDATE_VIEW_APPLICATION = '@@applications/UPDATE_VIEW_APPLICATION'
export const UPDATE_REVIEW_APPLICATION =
  '@@applications/UPDATE_REVIEW_APPLICATION'
export const UPDATE_REVIEW_APPLICATION_SUCCESS =
  '@@applications/UPDATE_REVIEW_APPLICATION_SUCCESS'
export const UPDATE_REVIEW_APPLICATION_FAILED =
  '@@applications/UPDATE_REVIEW_APPLICATION_FAILED'
export const FILTER_APPLICANTS = '@@applications/FILTER_APPLICANTS'
export const GET_TOTAL_APPLICATIONS = '@@applications/GET_TOTAL_APPLICATIONS'
export const GET_TOTAL_APPLICATIONS_SUCCESS =
  '@@applications/GET_TOTAL_APPLICATIONS_SUCCESS'
export const GET_TOTAL_APPLICATIONS_FAILED =
  '@@applications/GET_TOTAL_APPLICATIONS_FAILED'
export const REJECT_APPLICATION = '@@applications/REJECT_APPLICATION'
export const REJECT_APPLICATION_SUCCESS =
  '@@applications/REJECT_APPLICATION_SUCCESS'
export const REJECT_APPLICATION_FAILED =
  '@@applications/REJECT_APPLICATION_FAILED'
export const OFFER_ASSIGNMENT = '@@applications/OFFER_ASSIGNMENT'
export const APPLICATION_SAVE_ASSIGNMENT =
  '@@applications/APPLICATION_SAVE_ASSIGNMENT'
export const EDIT_ASSIGNMENT = '@@applications/EDIT_ASSIGNMENT'
export const PREVIEW_ASSIGNMENT = '@@applications/PREVIEW_ASSIGNMENT'
export const PREVIEW_ASSIGNMENT_SUCCESS =
  '@@applications/PREVIEW_ASSIGNMENT_SUCCESS'
export const PREVIEW_ASSIGNMENT_FAILED =
  '@@applications/PREVIEW_ASSIGNMENT_FAILED'
export const SIGN_ASSIGNMENT_PAD = '@@applications/SIGN_ASSIGNMENT_PAD'
export const SIGN_SEND_CONTRACT = '@@applications/SIGN_SEND_CONTRACT'
export const SIGN_SEND_CONTRACT_SUCCESS =
  '@@applications/SIGN_SEND_CONTRACT_SUCCESS'
export const SIGN_SEND_CONTRACT_FAILED =
  '@@applications/SIGN_SEND_CONTRACT_FAILED'
export const REJECT_WARNING = '@@applications/REJECT_WARNING'
export const CLOSE_APPLICATION_SNACKBAR =
  '@@applications/CLOSE_APPLICATION_SNACKBAR'
export const UPDATE_APPLICATION_STATUS =
  '@@applications/UPDATE_APPLICATION_STATUS'
export const UPDATE_APPLICATION_STATUS_SUCCESS =
  '@@applications/UPDATE_APPLICATION_STATUS_SUCCESS'
export const UPDATE_APPLICATION_STATUS_FAILED =
  '@@applications/UPDATE_APPLICATION_STATUS_FAILED'
export const GET_OFFER_FROM_LIGHT_ENTRE =
  '@@applications/GET_OFFER_FROM_LIGHT_ENTRE'
export const GET_OFFER_FROM_LIGHT_ENTRE_SUCCESS =
  '@@applications/GET_OFFER_FROM_LIGHT_ENTRE_SUCCESS'
export const GET_OFFER_FROM_LIGHT_ENTRE_FAILED =
  '@@applications/GET_OFFER_FROM_LIGHT_ENTRE_FAILED'
export const APPLICATION_PAGE_CHANGE = '@@applications/APPLICATION_PAGE_CHANGE'
export const PIN_APPLICATION = '@@applications/PIN_APPLICATION'
export const PIN_APPLICATION_SUCCESS = '@@applications/PIN_APPLICATION_SUCCESS'
export const PIN_APPLICATION_FAILED = '@@applications/PIN_APPLICATION_FAILED'

export const GET_WORKSHIFTS = '@@workshifts/GET_WORKSHIFTS'
export const GET_WORKSHIFTS_SUCCESS = '@@workshifts/GET_WORKSHIFTS_SUCCESS'
export const GET_WORKSHIFTS_FAILED = '@@workshifts/GET_WORKSHIFTS_FAILED'
export const GET_BILLABLE_HOURS = '@@workshifts/GET_BILLABLE_HOURS'
export const GET_BILLABLE_HOURS_SUCCESS =
  '@@workshifts/GET_BILLABLE_HOURS_SUCCESS'
export const GET_BILLABLE_HOURS_FAILED =
  '@@workshifts/GET_BILLABLE_HOURS_FAILED'
export const ADD_WORKSHIFTS = '@@workshifts/ADD_WORKSHIFTS'
export const ADD_WORKSHIFTS_SUCCESS = '@@workshifts/ADD_WORKSHIFTS_SUCCESS'
export const ADD_WORKSHIFTS_FAILED = '@@workshifts/ADD_WORKSHIFTS_FAILED'
export const GET_WORKSHIFT_BY_ID = '@@workshifts/GET_WORKSHIFT_BY_ID'
export const GET_WORKSHIFT_BY_ID_SUCCESS =
  '@@workshifts/GET_WORKSHIFT_BY_ID_SUCCESS'
export const GET_WORKSHIFT_BY_ID_FAILED =
  '@@workshifts/GET_WORKSHIFT_BY_ID_FAILED'
export const CONFIRM_BILLABLE_HOUR = '@@workshifts/CONFIRM_BILLABLE_HOUR'
export const CONFIRM_BILLABLE_HOUR_SUCCESS =
  '@@workshifts/CONFIRM_BILLABLE_HOUR_SUCCESS'
export const CONFIRM_BILLABLE_HOUR_FAILED =
  '@@workshifts/CONFIRM_BILLABLE_HOUR_FAILED'
export const DELETE_WORKSHIFT = '@@workshifts/DELETE_WORKSHIFT'
export const CANCEL_DIALOG = '@@workshifts/CANCEL_DIALOG'
export const REMOVE_WORKSHIFT = '@@workshifts/REMOVE_WORKSHIFT'
export const REMOVE_WORKSHIFT_SUCCESS = '@@workshifts/REMOVE_WORKSHIFT_SUCCESS'
export const REMOVE_WORKSHIFT_FAILED = '@@workshifts/REMOVE_WORKSHIFT_FAILED'
export const UPDATE_WORKSHIFT = '@@workshifts/UPDATE_WORKSHIFT'
export const UPDATE_WORKSHIFT_SUCCESS = '@@workshifts/UPDATE_WORKSHIFT_SUCCESS'
export const UPDATE_WORKSHIFT_FAILED = '@@workshifts/UPDATE_WORKSHIFT_FAILED'
export const CANCEL_EDIT_WORK_SHIFT = '@@workshifts/CANCEL_EDIT_WORK_SHIFT'
export const CLOSE_WORKSHIFT_SNACKBAR = '@@workshifts/CANCEL_WORKSHIFT_SNACKBAR'
export const WORKSHIFT_BY_EMAIL = '@@workshifts/WORKSHIFT_BY_EMAIL'
// Get signed light entrepreneurs
export const GET_SIGNED_LIGHT_ENTREPRENEUS =
  '@@workshifts/GET_SIGNED_LIGHT_ENTREPRENEUS'
export const GET_SIGNED_LIGHT_ENTREPRENEUS_SUCCESS =
  '@@workshifts/GET_SIGNED_LIGHT_ENTREPRENEUS_SUCCESS'
export const GET_SIGNED_LIGHT_ENTREPRENEUS_FAILED =
  '@@workshifts/GET_SIGNED_LIGHT_ENTREPRENEUS_FAILED'
export const WORKSHIFT_PAGE_CHANGE = '@@workshifts/WORKSHIFT_PAGE_CHANGE'
export const PIN_WORKSHIFT = '@@workshifts/PIN_WORKSHIFT'
export const PIN_WORKSHIFT_SUCCESS = '@@workshifts/PIN_WORKSHIFT_SUCCESS'
export const PIN_WORKSHIFT_FAILED = '@@workshifts/PIN_WORKSHIFT_FAILED'
export const SHOW_WORKSHIFT_FORM_DIALOG =
  '@@workshifts/SHOW_WORKSHIFT_FORM_DIALOG'
export const CLOSE_WORKSHIFT_FORM_DIALOG =
  '@@workshifts/CLOSE_WORKSHIFT_FORM_DIALOG'

export const COPY_PREVIOUS_ASSIGNMENT = 'COPY_PREVIOUS_ASSIGNMENT'
export const COPY_PREVIOUS_ASSIGNMENT_SUCCESS =
  'COPY_PREVIOUS_ASSIGNMENT_SUCCESS'
export const COPY_PREVIOUS_ASSIGNMENT_FAILED = 'COPY_PREVIOUS_ASSIGNMENT_FAILED'

export const GET_AREA_OF_WORK = 'GET_AREA_OF_WORK'
export const GET_AREA_OF_WORK_SUCCESS = 'GET_AREA_OF_WORK_SUCCESS'

export const GET_CONTRACT = '@@contract/GET_CONTRACT'
export const GET_CONTRACT_SUCCESS = '@@contract/GET_CONTRACT_SUCCESS'
export const GET_CONTRACT_FAILED = '@@contract/GET_CONTRACT_FAILED'
